import { render, staticRenderFns } from "./NationalHierarchy.vue?vue&type=template&id=878bf3aa&scoped=true&"
import script from "./NationalHierarchy.vue?vue&type=script&lang=ts&"
export * from "./NationalHierarchy.vue?vue&type=script&lang=ts&"
import style0 from "./NationalHierarchy.vue?vue&type=style&index=0&id=878bf3aa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878bf3aa",
  null
  
)

export default component.exports